/**
 * Typed provider EFEM admin API facade over the generated contract client.
 */

import { z } from 'zod';
import { providerEfemApi } from '../api/generated/providerEfem.api.js';
import type { EfemHardwareProfileData } from './EfemService.js';
import {
  EfemPeripheralMatrixResponseSchema,
  type EfemGatewayHardwareProfile,
  type GetEfemClientsResponseData,
  type TenantDeviceListResponse,
} from '@cnapse/shared/schemas.js';

class ProviderEfemService {
  async getProviderEfemClients(tenantId: string): Promise<GetEfemClientsResponseData> {
    return providerEfemApi.getClients({ tenantId }) as Promise<GetEfemClientsResponseData>;
  }

  async updateProviderEfemClient(
    tenantId: string,
    gatewaySerialNumber: string,
    clientData: { name?: string },
  ): Promise<GetEfemClientsResponseData> {
    return providerEfemApi.updateClient(
      { tenantId, gatewaySerialNumber },
      clientData,
    ) as Promise<GetEfemClientsResponseData>;
  }

  async getProviderEfemHardwareProfile(
    tenantId: string,
    gatewaySerialNumber: string,
  ): Promise<EfemHardwareProfileData> {
    return providerEfemApi.getHardwareProfile({ tenantId, gatewaySerialNumber }) as Promise<EfemHardwareProfileData>;
  }

  async putProviderEfemHardwareProfile(
    tenantId: string,
    gatewaySerialNumber: string,
    profile: EfemGatewayHardwareProfile,
  ): Promise<EfemHardwareProfileData> {
    return providerEfemApi.putHardwareProfile(
      { tenantId, gatewaySerialNumber },
      profile,
    ) as Promise<EfemHardwareProfileData>;
  }

  async getProviderEfemPeripheralMatrix(
    tenantId: string,
    gatewaySerialNumber: string,
  ): Promise<z.infer<typeof EfemPeripheralMatrixResponseSchema>['data']> {
    return providerEfemApi.getPeripheralMatrix({ tenantId, gatewaySerialNumber }) as Promise<
      z.infer<typeof EfemPeripheralMatrixResponseSchema>['data']
    >;
  }

  async getProviderTenantDevices(tenantId: string): Promise<TenantDeviceListResponse> {
    return providerEfemApi.listTenantDevices({ tenantId }) as Promise<TenantDeviceListResponse>;
  }
}

export const providerEfemService = new ProviderEfemService();
